import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {DecimalPipe} from '@angular/common';

@Component({
  selector: 'nf-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
  providers: [DecimalPipe]
})
export class SelectComponent implements OnInit, OnDestroy {

  @Input() isDisabled = false;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
    }
  }
  @Output() updateFilterData: EventEmitter<any> = new EventEmitter<any>();
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  pulse: any = {}; // 当前组件行数据
  column: any = {};
  displayText = '';
  popVisible = false;
  selectInputValue: string;
  editable = false; // 当前编辑状态
  selectedValue = [];
  tempOption;
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private decimalPipe: DecimalPipe
  ) { }

  ngOnInit() {
  }

  openPop() {
    this.tempOption = JSON.parse(JSON.stringify(this.column.config.option));
    this.popVisible = true;
  }

  closePop(visible) {
    // pop关闭的时候对比数据
    if (!visible) {
      if (JSON.stringify(this.tempOption) != JSON.stringify(this.column.config.option)) {
        this.column.config.option = this.tempOption;
      }
    }
  }

  // 新增下拉选项
  addNewOption() {
    if (!this.selectInputValue) {
      return;
    }
    if (this.checkExist()) {
      this.message.info('该选项已存在，无需重复添加!');
      return;
    }
    const optionId = this.getOptionId();
    let config = this.column.config;
    if (!config) {
      config = {
        remote: false,
        option: []
      };
    }
    config.option.push({id: optionId, title: this.selectInputValue.trim()});
    this.dataSubscription = this.taskService.doAddSelectOption(this.boardData.id, this.column.id, {config: config}).subscribe(res => {
      this.tempOption = JSON.parse(JSON.stringify(this.column.config.option));
      this.selectInputValue = '';
    });
  }

  // 检查新增选项是否存在
  checkExist(): boolean {
    let existFlag = false;
    if (this.column && this.column.config && this.column.config.option) {
      for (const option of this.column.config.option) {
        if (option.title.trim() === this.selectInputValue.trim()) {
          existFlag = true;
          break;
        }
      }
    }
    return existFlag;
  }

  // 获取新增选项id
  getOptionId() {
    let max = '0';
    if (this.column && this.column.config) {
      for (const option of this.column.config.option) {
        if (option.id > max) {
          max = option.id;
        }
      }
    }
    const id = parseInt(max, 10) + 1;
    return this.decimalPipe.transform(id, '6.0-0').replace(',', '');
  }

  // 更改下拉选项的值
  optionSelected(option) {
    // 值未更改，不发起请求
    if (this.pulse.columnValues[this.column['id']] && this.pulse.columnValues[this.column['id']]['option'] === option.id) {
      this.popVisible = false;
      return;
    }
    const param = {
      pulseIds: [this.pulse.id],
      columnId: this.column['id'],
      columnValue: {
        option: option.id
      }
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardData.id, param).subscribe(() => {},
      () => {
      this.message.error('修改失败！');
      }, () => {
        this.pulse.columnValues[this.column['id']] = {option: option.id};
        this.popVisible = false;
        this.updateFilterData.emit();
      });
  }

  editOption() {
    let pulses = this.boardData.boardData.pulses;
    this.selectedValue = [];
    for (let pulse of pulses) {
      let value = pulse.columnValues[this.column.id];
      if (value) {
        this.selectedValue.push(value.option);
      }
    }
    this.tempOption = JSON.parse(JSON.stringify(this.column.config.option));
    this.editable = true;
  }
  // 删除选项
  deleteOption(i: number) {
    this.column.config.option.splice(i, 1);
  }
  // 提交选项修改
  submitEdition() {
    this.dataSubscription = this.taskService.doAddSelectOption(this.boardData.id, this.column.id, {config: this.column.config}).subscribe(() => {},
      (err) => {
      console.log(err);
      this.message.error('提交失败!');
    }, () => {
      this.tempOption = JSON.parse(JSON.stringify(this.column.config.option));
      this.editable = false;
    });
  }
  // 取消编辑
  editCancel() {
    this.editable = false;
    this.column.config.option = this.tempOption;
  }

  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

}
